export default class ClientChargeForm {
    addressName
    number
    detail
    neighborhood
    zipCode
    city
    state
    contactPersonName
}
